const $ = jQuery.noConflict();

'use strict';
const ProductFinder = {
	/**
	 * @description Cache DOM and strings
	 * @type {object}
	 */
	$domProductListing: $('.js-products-listing'),
	$domForm: $('.js-product-finder-form'),
	$domToggleNav: $('.js-product-finder'),
	$domSubmitBtn: $('.js-init-request-btn'),
	$domCoatingField: $('input[name="coating"]'),
	$domPillsContainer: $('.js-selected-filters ul'),
	$domPillsClear: $('.js-selected-filters-clear'),
	$domCountContainer: $('.js-finder-count'),
	$domErrorMessage: $('.error-message'),
	$domH1: $('h1'),
	$domQuoteForm: {
		$typeOfCoating: $('.js-quote-form-type-of-coating'),
		$substrates: $('.js-quote-form-substrates'),
		$existingCoating: $('.js-quote-form-existing-coating'),
		$features: $('.js-quote-form-features'),
		$appFeatures: $('.js-quote-form-app-features'),
		$certifications: $('.js-quote-form-certifications'),
		$uvStability: $('.js-quote-form-uv-stability'),
		$products: $('.js-quote-form-products'),
	},
	classErrorVisible: 'is-visible',
	classDisabled: 'btn-inactive',
	filter: {},

	// initialization
	init: function() {
		if ($('body.slug-post-page-product-listing').length === 0) {
			return; // wrong page
		}
		this.bindEvents();
		this.updateSubmitButtonState(); // Initial check
		this.onFormChange(); // update controls
	},

	/** Bind Events */
	bindEvents: function() {

		// Monitor changes on required fields
		this.$domCoatingField.on('change', this.updateSubmitButtonState.bind(this));
		this.$domSubmitBtn.on('click', this.handleSubmit.bind(this));

		// monitor form changes
		this.$domForm.on('change', this.onFormChange);

		// un-toggle radio groups
		this.untoggleRadioGroup('coating');
		this.untoggleRadioGroup('existing_coating');
		this.untoggleRadioGroup('uv');

		// pills
		this.$domPillsContainer.on('click', '.pill', this.onPillsRemove);
		this.$domPillsClear.on('click', this.onPillsClear);
	},

	/**
	 * Enable/disable the submit button based on required field
	 */
	updateSubmitButtonState: function() {
		const isCoatingSelected = this.$domCoatingField.is(':checked');
		const isValid = isCoatingSelected /* && ... */;

		// toggle elements
		this.$domSubmitBtn.toggleClass(this.classDisabled, !isValid); // Enable button
		$('.js-validation-note').toggle(!isCoatingSelected); // Show the validation note

		// clear popup error messages
		if (isValid) {
			this.$domErrorMessage.removeClass(this.classErrorVisible); // Hide error message
		}
	},

	/**
	 * Handle form submission
	 */
	handleSubmit: function(e) {
		if (!this.$domCoatingField.is(':checked')) {
			e.preventDefault(); // Prevent form submission
			this.showError();
			this.scrollToForm(); // Scroll to the form
			return;
		}
		// Open the "Quote request" popup using Fancybox
		$.fancybox.open({
			src: $('.js-popup-quote-request'), // The "Quote request" popup element
			type: 'inline', // Fancybox type
			smallBtn: true, // Small close button
		});
		this.populateQuoteForm();
	},

	/**
	 * Show error message
	 */
	showError: function() {
		this.$domErrorMessage.addClass(this.classErrorVisible); // Display error message
	},

	/**
	 * Scroll to the top of the form
	 */
	scrollToForm: function() {
		if (this.$domToggleNav.css('position') === 'fixed') {
			// Scroll inside the toggle nav on mobile/tablet
			this.$domForm.animate({
				scrollTop: 0,
			}, 500);
		} else {
			// Scroll to the top of the page form on desktop
			this.$domForm[0].scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	},

	// on opening "quote" form popup fill its fields
	populateQuoteForm: function() {
		const extractSelected = (inputName) => ProductFinder.$domForm
			.find('input[name="'+inputName+'"]:checked')
			.map(function(){return $(this).parent().text().trim();})
			.get()
			.join(', ');
		ProductFinder.$domQuoteForm.$typeOfCoating.html(extractSelected('coating') || '-');
		//ProductFinder.$domQuoteForm.$appCondition.html(extractSelected('app_condition') || '-');
		ProductFinder.$domQuoteForm.$substrates.html(extractSelected('substrate') || '-');
		ProductFinder.$domQuoteForm.$existingCoating.html(extractSelected('existing_coating') || '-');
		ProductFinder.$domQuoteForm.$features.html(extractSelected('feature') || '-');
		ProductFinder.$domQuoteForm.$appFeatures.html(extractSelected('app_feature') || '-');
		ProductFinder.$domQuoteForm.$certifications.html(extractSelected('cert') || '-');
		ProductFinder.$domQuoteForm.$uvStability.html(extractSelected('uv') || '-');
		const products = $('.js-finder-card:visible')
			.map(function(){return $(this).find('h2').text().trim();})
			.get()
			.join(', ');
		ProductFinder.$domQuoteForm.$products.html(products || '-');
	},

	// handle "change" event of whole form
	onFormChange: function() {
		ProductFinder.updateFilter();
		ProductFinder.updateCards();
		ProductFinder.updatePills();
		ProductFinder.updateVisibleOptions('.js-finder-substrate', 'substrates');
		ProductFinder.updateVisibleOptions('.js-finder-feature', 'features');
		ProductFinder.updateVisibleOptions('.js-finder-appfeature', 'appFeatures');
		ProductFinder.updateVisibleOptions('.js-finder-cert', 'certificates');
	},

	// update filter struct
	updateFilter: function() {
		ProductFinder.filter = {
			'coating': ProductFinder.$domForm.find('input[name=coating]:checked').val() || '',
			//'app_type': ProductFinder.$domForm.find('input[name=app_type]:checked').val() || '',
			//'app_condition': ProductFinder.$domForm.find('input[name=app_condition]:checked').map(function(){return $(this).val();}).toArray(),
			'substrate': ProductFinder.$domForm.find('input[name=substrate]:checked').map(function(){return $(this).val();}).toArray(),
			'existing_coating': ProductFinder.$domForm.find('input[name=existing_coating]:checked').val() || '',
			'feature': ProductFinder.$domForm.find('input[name=feature]:checked').map(function(){return $(this).val();}).toArray(),
			'app_feature': ProductFinder.$domForm.find('input[name=app_feature]:checked').map(function(){return $(this).val();}).toArray(),
			'cert': ProductFinder.$domForm.find('input[name=cert]:checked').map(function(){return $(this).val();}).toArray(),
			'uv': ProductFinder.$domForm.find('input[name=uv]:checked').val() || '',
		};
		ProductFinder.updateUrl();
	},

	// update browser URL
	updateUrl: function() {
		const query = [];
		Object.keys(this.filter).forEach(filter => {
			if (typeof ProductFinder.filter[filter] === 'string' && ProductFinder.filter[filter]) {
				query.push(filter + '=' + ProductFinder.filter[filter]);
			} else if (ProductFinder.filter[filter].length > 0) {
				query.push(filter + '=' + (ProductFinder.filter[filter].join(',')));
			}
		});
		const pageUrl = window.location.origin + window.location.pathname;
		const newUrl = query.length ? pageUrl + '?' + query.join('&') : pageUrl;
		window.history.pushState({path: newUrl}, '', newUrl);
	},

	// update visibility of cards
	updateCards: function() {
		window.fwsProductListing.forEach(prod => {
			const isVisible = ProductFinder.filterCard(prod);
			const $container = this.$domProductListing.find('.js-finder-card[data-product-id="'+prod.id+'"]');
			$container.toggle(isVisible);
		});
		ProductFinder.updateCategoryGroups();
		ProductFinder.$domCountContainer.text($('.js-finder-card:visible').length + ' Results');
	},

	// hide category-title rows left with no visible cards, update their product count
	updateCategoryGroups: function() {
		this.$domProductListing.find('.js-category-group').each(function() {
			const $group = $(this);
			// checked on each card's own "display" instead of jQuery's ":visible" (which also
			// requires ancestors to be visible) - $group itself may still be hidden at this point
			const count = $group.find('.js-finder-card').filter(function() {
				return $(this).css('display') !== 'none';
			}).length;
			$group.find('.js-category-count').text('(' + count + ' products)');
			$group.toggle(count > 0);
		});
	},

	// update content of pills
	updatePills: function() {
		this.$domPillsContainer.find('.pill').remove();
		const $firstLi = this.$domPillsContainer.find('li:first');
		Object.keys(this.filter).forEach(filter => {
			if (typeof ProductFinder.filter[filter] === 'string' && ProductFinder.filter[filter]) {
				ProductFinder.addNewPill(filter, ProductFinder.filter[filter], $firstLi);
			} else {
				Object.values(ProductFinder.filter[filter]).forEach(value => {
					ProductFinder.addNewPill(filter, value, $firstLi);
				});
			}
		});
		this.$domPillsClear.toggle(this.$domPillsContainer.find('.pill').length > 0); // visibility of "Clear"
		ProductFinder.updateH1();
	},

	// change text of <h1> tag
	updateH1: function() {
		this.$domH1.text(this.$domPillsContainer.find('.pill').length > 0 ? 'My Products' : 'Products');
	},

	// create and append new pill to container
	addNewPill: function(filterName, slug, $firstLi) {
		const template = `
			<li class="pill" data-filter="{F}" data-option="{S}">
				{T}<button class="pill__remove">X</button>
			</li>`;
		const input = ProductFinder.$domForm.find('input[name="'+filterName+'"][value="'+slug+'"]');
		const title = input.closest('label').text();
		const pill = template.replace('{F}', filterName).replace('{S}', slug).replace('{T}', title);
		$(pill).insertBefore($firstLi);
	},

	// return true if product should be visible
	filterCard: function(prod) {
		if (ProductFinder.filter.coating && (prod.technology.coating?.value) !== ProductFinder.filter.coating) {
			return false;
		}
		if (ProductFinder.filter.substrate.length && prod.substrates.filter(value => ProductFinder.filter.substrate.includes(value.slug)).length === 0) {
			return false;
		}
		if (ProductFinder.filter.existing_coating && prod.existingCoating.length && !prod.existingCoating.includes(ProductFinder.filter.existing_coating)) {
			return false;
		}
		if (ProductFinder.filter.feature.length && prod.features.filter(value => ProductFinder.filter.feature.includes(value.slug)).length === 0) {
			return false;
		}
		if (ProductFinder.filter.app_feature.length && prod.appFeatures.filter(value => ProductFinder.filter.app_feature.includes(value.slug)).length === 0) {
			return false;
		}
		if (ProductFinder.filter.cert.length && prod.certificates.filter(value => ProductFinder.filter.cert.includes(value.slug)).length === 0) {
			return false;
		}
		if (ProductFinder.filter.uv && (prod.uvResistance?.slug || '') !== ProductFinder.filter.uv) {
			return false;
		}
		return true;
	},

	// handle removing pills
	onPillsRemove: function(event) {
		const $target = $(event.currentTarget);
		const filterName = $target.data('filter');
		const slug = $target.data('option');
		ProductFinder.clearControl(filterName, slug).trigger('change');
	},

	// handle click on "Clear" button
	onPillsClear: function() {
		ProductFinder.$domPillsContainer.find('.pill').each(function() {
			const filterName = $(this).data('filter');
			const slug = $(this).data('option');
			ProductFinder.clearControl(filterName, slug);
		});
		ProductFinder.$domForm.trigger('change');
	},

	// find control, clear prop and return element
	clearControl(filterName, slug) {
		const input = ProductFinder.$domForm.find('input[name="'+filterName+'"][value="'+slug+'"]');
		input.prop('checked', false);
		return input;
	},

	// un-check already checked radio button
	untoggleRadioGroup: function(controlName) {
		const $container = this.$domForm.find('input[name='+controlName+']:first').closest('.product-finder__form-field');
		const initValue = this.$domForm.find('input[name='+controlName+']:checked').val();
		$container.data('old-value', initValue);
		this.$domForm.find('input[name='+controlName+']').on('click', function() {
			const newValue = $(this).val();
			if ($container.data('old-value') === newValue) {
				$container.data('old-value', '');
				$(this).prop('checked', false);
				$(this).trigger('change'); // coz resetting button will not trigger form-onchange we must do that manually
				return;
			}
			$container.data('old-value', newValue);
		});
	},

	// update visibility of offered filter options
	updateVisibleOptions: function(selector, field) {
		// get all values
		const allOptions = {};
		let anyVisible = !ProductFinder.filter.coating;
		const $inputs = $(selector + ' input');
		$inputs.each((idx, $el) => {allOptions[$($el).val()] = !ProductFinder.filter.coating;});
		// mark substrates of products in selected coating option
		if (ProductFinder.filter.coating) {
			window.fwsProductListing.forEach(prod => {
				if (ProductFinder.filter.coating && (prod.technology.coating?.value) === ProductFinder.filter.coating) {
					prod[field].forEach(value => {
						anyVisible = true;
						allOptions[value.slug] = true;
					});
				}
			});
		}
		// update controls
		$inputs.each((idx, $el) => $($el).parent().toggle(allOptions[$($el).val()]));
		// update section visibility
		$(selector).closest('.product-finder__form-field').toggle(anyVisible);
	},

};

export default ProductFinder;
